import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const AboutUs = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 32 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      fill="none"
      viewBox="0 0 32 32"
      ref={forwardedRef}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.89228 4.86665C5.79848 4.09235 6.40288 3.41033 7.18284 3.41033H24.0914C24.879 3.41033 25.4857 4.10514 25.3795 4.88557L22.5085 25.989C22.4209 26.6333 21.8706 27.1138 21.2204 27.1138H9.7391C9.08159 27.1138 8.5276 26.6229 8.44853 25.9701L5.89228 4.86665Z"
        fill="#9A5BFF"
        stroke="#2B2F38"
        strokeWidth="1.4"
      />
      <mask
        id="mask0_7068_442"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="5"
        y="2"
        width="22"
        height="26"
      >
        <path
          d="M5.89228 4.86665C5.79848 4.09235 6.40288 3.41033 7.18284 3.41033H24.0914C24.879 3.41033 25.4857 4.10514 25.3795 4.88557L22.5085 25.989C22.4209 26.6333 21.8706 27.1138 21.2204 27.1138H9.7391C9.08159 27.1138 8.5276 26.6229 8.44853 25.9701L5.89228 4.86665Z"
          fill="#FFDB59"
          stroke="#2B2F38"
          strokeWidth="1.4"
        />
      </mask>
      <g mask="url(#mask0_7068_442)">
        <path
          d="M25.9545 24.6676C25.9545 29.2843 22.9598 32.759 19.5625 32.759C16.1652 32.759 13.1705 29.2843 13.1705 24.6676C13.1705 20.0509 16.1652 16.5762 19.5625 16.5762C22.9598 16.5762 25.9545 20.0509 25.9545 24.6676Z"
          fill="#BEE9FC"
          stroke="#2B2F38"
          strokeWidth="1.4"
        />
        <path
          d="M17.6641 24.2874C17.6641 27.3917 15.0944 29.9312 11.8959 29.9312C8.69731 29.9312 6.12767 27.3917 6.12767 24.2874C6.12767 21.1832 8.69731 18.6436 11.8959 18.6436C15.0944 18.6436 17.6641 21.1832 17.6641 24.2874Z"
          fill="#FFDB59"
          stroke="#2B2F38"
          strokeWidth="1.4"
        />
      </g>
      <path
        d="M5.89228 4.86665C5.79848 4.09235 6.40288 3.41033 7.18284 3.41033H24.0914C24.879 3.41033 25.4857 4.10514 25.3795 4.88557L22.5085 25.989C22.4209 26.6333 21.8706 27.1138 21.2204 27.1138H9.7391C9.08159 27.1138 8.5276 26.6229 8.44853 25.9701L5.89228 4.86665Z"
        stroke="#2B2F38"
        strokeWidth="1.4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.3249 7.55492C22.7115 7.55492 23.0249 7.24152 23.0249 6.85492C23.0249 6.46833 22.7115 6.15492 22.3249 6.15492L20.7701 6.15492C20.3835 6.15492 20.0701 6.46833 20.0701 6.85492C20.0701 7.24152 20.3835 7.55492 20.7701 7.55492L22.3249 7.55492ZM9.46497 7.55506C9.85157 7.55506 10.165 7.24166 10.165 6.85506C10.165 6.46846 9.85157 6.15506 9.46497 6.15506L8.98299 6.15506C8.59639 6.15506 8.28299 6.46846 8.28299 6.85506C8.28299 7.24166 8.59639 7.55506 8.98299 7.55506L9.46497 7.55506ZM19.3416 6.85492C19.3416 7.24152 19.0282 7.55492 18.6416 7.55492L17.0868 7.55492C16.7002 7.55492 16.3868 7.24152 16.3868 6.85492C16.3868 6.46833 16.7002 6.15492 17.0868 6.15492L18.6416 6.15492C19.0282 6.15492 19.3416 6.46833 19.3416 6.85492ZM14.9941 7.55478C15.3807 7.55478 15.6941 7.24138 15.6941 6.85478C15.6941 6.46819 15.3807 6.15478 14.9941 6.15478L13.4393 6.15478C13.0527 6.15478 12.7393 6.46819 12.7393 6.85478C12.7393 7.24138 13.0527 7.55478 13.4393 7.55478L14.9941 7.55478Z"
        fill="#2B2F38"
      />
      <path
        d="M14.5414 13.3157C14.5414 14.8666 13.3339 16.0814 11.8959 16.0814C10.4578 16.0814 9.25029 14.8666 9.25029 13.3157C9.25029 11.7647 10.4578 10.55 11.8959 10.55C13.3339 10.55 14.5414 11.7647 14.5414 13.3157Z"
        fill="#FFDB59"
        stroke="#2B2F38"
        strokeWidth="1.4"
      />
      <path
        d="M22.2393 12.1185C22.2393 13.5908 21.1181 14.7183 19.8143 14.7183C18.5104 14.7183 17.3893 13.5908 17.3893 12.1185C17.3893 10.6463 18.5104 9.51873 19.8143 9.51873C21.1181 9.51873 22.2393 10.6463 22.2393 12.1185Z"
        fill="#BEE9FC"
        stroke="#2B2F38"
        strokeWidth="1.4"
      />
      <path
        d="M14.5466 17.5208L17.2534 30.1948L20.0815 27.2425L22.8894 30.7929L26.018 27.9404L23.1124 24.6861L26.4551 22.1433L14.5466 17.5208Z"
        fill="white"
        stroke="#2B2F38"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
})

export default AboutUs
